import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { getSports } from '../../data/sports';

interface MsjProps {
    children?: ReactElement;
    challengeId?: string;
    complete?: boolean;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function MsjSuccessDefy(props: MsjProps): JSX.Element {
    const { children, challengeId, complete } = props;
    const back = `${getSports().url}/desafiar/equipo/filter?challengeId=${challengeId}`;
    return (
        <div className="flex items-center justify-center relative mt-14">
            <div
                className={`inline-flex bg-sm-rent absolute  -top-14 border-4 border-white  items-center justify-center p-2 rounded-full text-white  focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white`}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-14 h-14"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
            </div>
            <div className={`w-full md:w-1/2 text-white bg-sm-rent items-center text-center rounded-3xl px-10 py-2 `}>
                {children}

                <div className="pt-4 font-bold">
                    {challengeId !== undefined ? (
                        <>
                            <Link to={back} className="hover:underline" href={back}>
                                Ir al Desafío
                            </Link>
                            <Link
                                to={`${getSports().url}/desafiar/pago/filter?challengeId=${challengeId}`}
                                className="hover:underline block my-2"
                                href="/"
                            >
                                Pagar Desafio
                            </Link>
                        </>
                    ) : (
                        <Link to={'/'} className="hover:underline" href={'/'}>
                            Ir al Home
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
}
